// Types e constants compartilhados pelos sub-componentes de Extrato Bancário.
// Extraído de FinanceiroExtratoBancario.tsx durante refactor topológico.

export interface Transacao {
  id: string; fitid: string; banco: string; conta_id: string; conta_label: string;
  data_transacao: string; valor: number; tipo_ofx: string; descricao: string;
  name_original?: string | null;   // payee <NAME> do OFX — destinatário puro, sem ruído do memo
  classificacao: string; classificacao_origem: string | null;
  classificado_em: string | null; classificado_por: string | null;
  observacoes: string | null;
  parcela_id: string | null; lancamento_pagar_id: string | null; par_transacao_id: string | null;
  parcela_label?: string | null; parcela_cliente_nome?: string | null;
  lancamento_pagar_label?: string | null;
  lancamento_categoria_dre?: string | null; lancamento_grupo_dre?: string | null;
  par_conta_label?: string | null;
  // FZ-TRANSF fase 2 — vínculo com transferência do Conta Azul
  transferencia_ca_id?: string | null;
  transferencia_ca_label?: string | null;  // conta do outro lado (ex. SICOOB) quando conciliada
  transf_ca_sugestao?: { id: string; outro: string; origem: string; destino: string } | null;
  importado_em: string;
}

export interface CandidatoConciliacao {
  tipo: 'parcela' | 'lancamento_pagar' | 'transferencia' | 'transferencia_ca';
  id: string; score: number; label: string; valor: number; data: string; sub: string;
  valor_liquido?: number | null;  // CR: valor liquido apos retencoes (multi-CR usa)
  _parcial?: boolean;
  _saldoApos?: number;  // saldo restante apos este vinculo; ~0 = quita/completa
  _afinidade?: boolean;
  _mesmaPessoa?: boolean;
}

export interface ContaDisponivel { banco: string; conta_id: string; conta_label: string; }

export interface ResultadoBuscaManual {
  tipo: 'parcela' | 'lancamento_pagar';
  id: string; label: string; valor: number;
  valor_liquido?: number | null;
  valor_recebido?: number;
  // Quanto ainda falta entrar (CR) ou sair (CP). Mesma conta do "Falta" da aba
  // Pagamento da parcela — é o que diz se o vínculo quita ou deixa saldo.
  falta?: number;
  data: string; sub: string; status?: string;
}

// Classificacoes que dispensam vinculo com CR/CP — sao movimentacoes patrimoniais
// ou operacionais automaticas que ficam na propria transacao OFX (sem precisar
// casar com lancamento_pagar/contas_a_receber). Considera-las "conciliadas via
// classificacao" pra subir a metrica de cobertura de conciliacao.
export const CLASSIF_AUTO_CONCILIA = new Set([
  'aplicacao_investimento',
  'resgate_investimento',
  'rendimento_aplicacao',
  'tarifa',
  'imposto',
  'estorno',
]);

export const CLASSIFICACOES: Array<{ id: string; label: string; cor: string; bg: string; emoji: string }> = [
  { id: 'nao_classificada', label: 'Não classificada', cor: '#888', bg: '#F2F2F4', emoji: '❓' },
  { id: 'receita', label: 'Receita', cor: '#0a7f4a', bg: '#E8F5EE', emoji: '💰' },
  { id: 'despesa', label: 'Despesa', cor: '#B91626', bg: '#FDECEC', emoji: '💸' },
  { id: 'transferencia_entre_contas', label: 'Transferência', cor: '#0930D0', bg: '#EFF3FF', emoji: '🔄' },
  { id: 'aplicacao_investimento', label: 'Aplicação', cor: '#7C3AED', bg: '#F3E8FF', emoji: '📈' },
  { id: 'resgate_investimento', label: 'Resgate', cor: '#7C3AED', bg: '#F3E8FF', emoji: '📉' },
  { id: 'rendimento_aplicacao', label: 'Rendimento', cor: '#0a7f4a', bg: '#E8F5EE', emoji: '✨' },
  { id: 'tarifa_bancaria', label: 'Tarifa', cor: '#B07500', bg: '#FFF8E8', emoji: '🏦' },
  { id: 'imposto', label: 'Imposto', cor: '#B07500', bg: '#FFF8E8', emoji: '📋' },
  { id: 'estorno', label: 'Estorno', cor: '#666', bg: '#FAFBFF', emoji: '↩' },
];
export const CLASSIF_MAP = Object.fromEntries(CLASSIFICACOES.map(c => [c.id, c]));

// 🚨 As chaves são os apelidos que o leitor de OFX produz (_bancoFromFid em
// dre-engine/index.js) e a lista do cadastro de conta (contaCadastro.js) —
// teste de concordância em dre-engine/tests/contas-financeiras/.
export const BANCO_LABEL: Record<string, string> = {
  inter: 'Inter', itau: 'Itaú', sicoob: 'SICOOB', safra: 'Safra', bradesco: 'Bradesco',
  bb: 'BB', santander: 'Santander', caixa: 'Caixa', outro: 'Outro',
};
